import sly from '../assets/sly.png';
import noodles from '../assets/noodles.png';
import al from '../assets/al.png';
import em from '../assets/em.png';
import wade from '../assets/wade.png';
import fj from '../assets/fj.png';
import kay from '../assets/kay.png';
import sock from '../assets/sock.png';
import maddie from '../assets/maddie.png';
import sy from '../assets/sy.png';

const data = [
  {
    id: 0,
    name: 'Nate Orobono',
    mc: 'Sly3G',
    img: sly,
    job: 'Owner, Builder, 3D-Modeler',
  },
  {
    id: 1,
    name: 'Emery',
    mc: 'Emery_Exe',
    img: em,
    job: 'Owner, Builder, Writer, Planner',
  },
  {
    id: 2,
    name: 'Alex Shevlin',
    mc: 'woermboy',
    img: al,
    job: 'Owner, Developer, Builder, 3D-Modeler',
  },
  {
    id: 3,
    name: 'NOODLLLES',
    mc: 'NOODLLLES',
    img: noodles,
    job: 'Builder, 3D-Modeler',
  },
  {
    id: 4,
    name: 'Wade',
    mc: 'AwooMP4',
    img: wade,
    job: 'Builder, Writer',
  },
  {
    id: 5,
    name: 'Gabriel Rose',
    mc: 'Jabeu',
    img: fj,
    job: 'Builder, Backend Developer',
  },
  {
    id: 6,
    name: 'Kay Shrieve',
    mc: 'KayGraceX',
    img: kay,
    job: 'Backend Developer',
  },
  {
    id: 7,
    name: 'Maddie',
    mc: 'Maddie1821',
    img: maddie,
    job: 'Builder',
  },
  {
    id: 8,
    name: 'Syrus',
    mc: 'Syrus2010',
    img: sy,
    job: 'Builder, Moderator',
  }
]

export default data;